/*eslint no-use-before-define:0 *///TODO REMOVE THIS
var dd = require('ES/lib/dd');
var _ = require('ES/lib/lodash');
var radio = require('ES/lib/radio');
var esUtils = require('ES/utils/esUtils');
var FormMixin = require('ES/widgets/forms/FormMixin');
var FormUtils = require('../../../../../utils/FormUtils');
var HorizontalFields = require('ES/widgets/HorizontalFields');
var EventFormUnsavedChangeMixin = require('../../EventFormUnsavedChangeMixin');

module.exports = dd.createClass({
	__onSubmit: function(data){
		var event = _.cloneDeep(this.props.event);
		var product = this.props.product;

		if(!_.isArray(event.ProductSale)){
			event.ProductSale = [];
		}
		if(!product || product.id < 0){
			product = {id: 0, eid: event.eid};
			event.ProductSale.push(product);
		}
		_.each(event.ProductSale, function(p){
			if(p.id == product.id){
				p.groupcode = data.groupcode;
				p.description = data.description;
				p.qtysold = FormUtils.floatOr0(data.qtysold);
				p.qtyshipped = FormUtils.floatOr0(data.qtyshipped);
				p.priceeach = FormUtils.floatOr0(data.priceeach);
			}
		});
		radio('save_Event').broadcast(event);
		this.__close();
	},
	__onDelete: esUtils.wrapPreventDefault(function(){
		var event = _.cloneDeep(this.props.event);
		var product = this.props.product;
		event.ProductSale = _.reject(event.ProductSale, function(p){
			return p.id == product.id;
		});
		radio('save_Event').broadcast(event);
		this.__close();
	}),
	__close: function(){
		if(_.isFunction(this.props.onClose)){
			this.props.onClose();
		}
	},
	render: function(){
		var event = this.props.event;
		var Displaylists = this.props.Displaylists;
		var product = this.props.product;
		var onClose = this.props.onClose;

		return dd.div({className: 'ProductSaleForm'},
			DaForm({
				event: event,
				Displaylists: Displaylists,
				product: product,
				onSubmit: this.__onSubmit,
				onDelete: this.__onDelete,
				onClose: onClose
			})
		);
	}
});

var DaForm = dd.createClass({
	mixins: [FormMixin, _.omit(EventFormUnsavedChangeMixin, 'onFormChanged')],
	getInitialValuesSourceVersion: function(props){
		return esUtils.getEventVersionIdentifier(props.event) + '-' + ((props.product && props.product.id) || 0);
	},
	getInitialValues: function(props){
		var product = props.product;
		if(!product || product.id < 1){
			return null;
		}
		return {
			groupcode: product.groupcode,
			description: product.description,
			qtysold: product.qtysold,
			qtyshipped: product.qtyshipped,
			priceeach: product.priceeach
		};
	},
	onFormChanged: function(field_path, new_value){
		if(field_path === 'groupcode'){
			var data = this.state.data || {};
			var product_codes = this.__getProductCodes();
			var code = product_codes[new_value];
			if(code){
				data.qtysold = code.qtysold;
				data.groupcode = code.groupcode;
				data.priceeach = code.priceeach;
				data.qtyshipped = code.qtyshipped;
				data.description = code.description;
				this.setState({data: data});
			}
		}
		//from EventFormUnsavedChangeMixin
		this.__checkForChangesMade();
	},
	__getProductCodes: function(){
		var event = this.props.event;
		var Displaylists = this.props.Displaylists;
		return _.sortBy(_.uniq(_.filter(_.flattenDeep(_.map(_.filter(Displaylists && Displaylists.perspeaker, function(speaker){
			return _.includes(event && event.sids, speaker.sid);
		}), 'productcodes')), function(code){
			return _.isString(code && code.groupcode);
		}), 'groupcode'), function(code){
			return _.get(code, "groupcode", "").toUpperCase();
		});
	},
	buildFields: function(){
		return {
			groupcode: {
				label: 'Code',
				type: 'combo',
				options: _.object(_.map(this.__getProductCodes(), function(code, i){
					return [i, code.groupcode];
				})),
				placeholder: 'Code'
			},
			description: {
				label: 'Description',
				type: 'text',
				placeholder: 'Description',
				validate: FormUtils.v.optional
			},
			qtysold: {
				label: 'Number Sold',
				type: 'text',
				placeholder: 'Number Sold',
				validate: FormUtils.v.optional
			},
			qtyshipped: {
				label: 'Number Shipped',
				type: 'text',
				placeholder: 'Number Shipped',
				validate: FormUtils.v.optional
			},
			priceeach: {
				label: 'Price',
				type: 'text',
				placeholder: 'Price',
				validate: FormUtils.v.blankOr(FormUtils.v.currency)
			}
		};
	},
	__onCancel: esUtils.wrapPreventDefault(function(){
		this.updateUnsavedState(false);
		this.props.onClose();
	}),
	render: function(){
		var fields = this.buildFields();
		var errors = this.state.errors || {};
		var onDelete = this.props.onDelete;
		var product = this.props.product;

		return dd.form({className: 'form-horizontal', onSubmit: this._form_onSubmit},
			HorizontalFields({
				fields: fields,
				errors: errors,
				buildInput: this._form_buildInput
			}),
			HorizontalFields.FormButtons({
				right_align_buttons: true,
				submit_btn_text: product && product.id > 0 ? 'Save' : 'Add',
				onCancel: this.__onCancel,
				onDelete: product && product.id > 0 ? onDelete : null
			})
		);
	}
});



// WEBPACK FOOTER //
// ./src/components/main_view/event_area/tabs/services/ProductSaleForm.js